module.exports = __webpack_public_path__ + "img/exchangebox.79dc1db2.svg";